import { render, staticRenderFns } from "./bundle.vue?vue&type=template&id=635bba2e&scoped=true&"
import script from "./bundle.vue?vue&type=script&lang=js&"
export * from "./bundle.vue?vue&type=script&lang=js&"
import style0 from "./bundle.vue?vue&type=style&index=0&id=635bba2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635bba2e",
  null
  
)

export default component.exports